import {Button, Table, Switch, message, Popconfirm, Pagination} from "antd";
import {PlusSquareOutlined} from '@ant-design/icons';
import AddTiming from "./com/addTimimg";
import React from "react";

import './index.sass';
import api from "../../utils/api";
import {PeriodicalExporter} from "../../components/ExportOrder/ExporterBoard";
import {executeConditionConstructor, searchConditionConstructor} from "../../utils/functions";
import SystemType from "../../utils/SystemType";
import {
    AddRepeatCustomOrderExportTaskEvent
} from "../../events/AddCustomOrderExportTaskEvent";
import EventDispatcher from "../../events";
import {LoadCustomOrderExportTasksEvent} from "../../events/LoadCustomOrderExportTaskEvent";
import {shallowEqual} from "react-redux";

const TasksTable = (props) => {
    const {dataSource, page, total, pageSize, nextPageDataSource} = props;
    const columns = [
        {
            title: '导出项目名称',
            width: 180,
            key: "name",
            dataIndex: "name",
        },
        {
            title: '导出类型',
            width: 180,
            key: "created_at",
            render: (ctx) => {
                return ctx['task_type'] === 2 ? '定时任务' : '即时导出';
            }
        },
        {
            title: '上一次运行时间',
            width: 180,
            key: "last_execute_time",
            dataIndex: "last_execute_time",
        }, {
            title: '下一次运行时间',
            width: 180,
            key: "next_execute_time",
            dataIndex: "next_execute_time",
        },
        {
            title: '创建时间',
            width: 180,
            key: "created_at",
            dataIndex: "created_at",
        },
        {
            title: '状态',
            width: 180,
            key: "status",
            render: (ctx) => {
                return <Switch checkedChildren="开启" unCheckedChildren="关闭" checked={ctx.status === 1}></Switch>
            }
        }, {
            title: '操作',
            width: 180,
            render: () => {
                return <div className="optWrapper">
                    <div className="pointer download warn">下载最新记录</div>
                    <div className="pointer download warn">查看记录</div>
                </div>
            }
        }
    ];
    const pagination = {
        current: page,
        total: total,
        pageSize: pageSize,
        showSizeChanger: false,
        onChange: async (page) => {
            nextPageDataSource(page, pageSize);
        }
    };
    return (<Table
        columns={columns}
        dataSource={dataSource}
        pagination={pagination}/>);
}
export default class OrdersTiming extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dataResources: {},
            page: 1,
            total: 0,
            periodicalExporterShow: false,
            pageSize: 15,
        }
    }

    componentDidMount() {
        this.emitLoadCustomOrderExportTaskEvent(this.state.page, this.state.pageSize);
    }

    shouldComponentUpdate(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): boolean {
        return !shallowEqual(nextProps, this.props) || !shallowEqual(nextState, this.state);
    }

    emitLoadCustomOrderExportTaskEvent = (page, pageSize) => {
        let event = new LoadCustomOrderExportTasksEvent({
            'system': SystemType.MERCHANT_ADMIN,
            'page': page,
            'page_size': pageSize,
        });
        event['success'] = this.receiveTasks
        EventDispatcher.dispatch(event).then(() => {
        })
    }

    receiveTasks = ({data, meta}) => {
        const {dataResources} = this.state;
        const page = meta['paginate']['current_page'];
        const total = meta['paginate']['total_count'];
        dataResources[page] = data;
        this.setState({dataResources: {...dataResources}, page: page, total: total})
    }

    addOrderExportTask = async (fields, strategies, condition, remark) => {
        // 组装条件
        let searchCondition = searchConditionConstructor(condition);
        let executeCondition = executeConditionConstructor(condition);
        const params = {
            'system': SystemType.MERCHANT_ADMIN,
            'name': '订单定时导出任务（' + (new Date()).toLocaleDateString() + ')',
            'search_condition': searchCondition,
            'execute_condition': {
                'repeat_grep_days': 0,
                ...executeCondition
            },
            'export_fields': fields,
            'remark': remark
        };

        const event = new AddRepeatCustomOrderExportTaskEvent(params);
        let result = EventDispatcher.dispatch(event);
        return await result;
    }

    render() {
        let {periodicalExporterShow, dataResources, page, pageSize, total} = this.state
        return (
            <div className='ordersTiming'>
                <div className='mgb20'>
                    <div className="optBox mgb20">
                        <Button onClick={() => {
                            this.setState({periodicalExporterShow: true});
                        }} icon={<PlusSquareOutlined/>} className='themeBtn addTiming' size=''>添加单定时导出任务</Button>
                    </div>

                    <div className="tasksWrapper">
                        <TasksTable
                            nextPageDataSource={this.emitLoadCustomOrderExportTaskEvent}
                            dataSource={dataResources[page]}
                            page={page}
                            pageSize={pageSize}
                            total={total}/>
                    </div>
                </div>
                {periodicalExporterShow &&
                <PeriodicalExporter closePopup={() => this.setState({periodicalExporterShow: false})}
                                    submit={this.addOrderExportTask}/>}
            </div>
        )
    }
}